import React from 'react'
import {getProductColor} from './ProductColors'
import {IconWrapper} from './ProductIcon.style'
import ThryvLogo from '../../assets/icons/thryvLogo.svg'

export function ProductIcon({productName, size = 24}) {
  const bg = getProductColor(productName)

  return (
    <IconWrapper bg={bg} size={size}>
      <img src={ThryvLogo} alt="thryv" />
    </IconWrapper>
  )
}
